export const getFormattedDates = (date: string | number | undefined) => {
  if (!date) return

  const accessible = new Date(date).toLocaleDateString('pt-br', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  const visually = new Date(date).toLocaleDateString('pt-br')

  return { accessible, visually }
}
